import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EnvBarComponent } from './env-bar.component';

@NgModule({
  declarations: [EnvBarComponent],
  imports: [CommonModule, RouterModule],
  exports: [EnvBarComponent],
})
export class EnvBarModule {}
